import { render, staticRenderFns } from "./ItsStockRawInBound.vue?vue&type=template&id=3a89c9da&scoped=true&"
import script from "./ItsStockRawInBound.vue?vue&type=script&lang=js&"
export * from "./ItsStockRawInBound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a89c9da",
  null
  
)

export default component.exports